import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { getContentDetails } from "../../../../redux/actions/campaignActions";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import "../Add/addnew.scss";

const Editcontent = () => {
  const [contents, setContents] = useState("");
  const [loading, setLoading] = useState(false);
  const id = useParams();

  let token = localStorage.getItem("accessToken");
  const navitage = useNavigate();
  const dispatch = useDispatch();
  const contentView = useSelector((state) => state.contentView);
  const { content } = contentView;

  useEffect(() => {
    dispatch(getContentDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (contentView) {
      if (contentView?.loading !== undefined) {
        setLoading(contentView?.loading);
      }
    }
  }, [contentView]);

  useEffect(() => {
    if (content) {
      setValue("page_title_en", content?.data?.page_title_en);
      setValue("page_title_fr", content?.data?.page_title_fr);
      setValue("page_title_it", content?.data?.page_title_it);
      setValue("page_title_sp", content?.data?.page_title_es);
      setValue("page_title_pl", content?.data?.page_title_pl);
      setValue("slug", content?.data?.slug);
      setValue("aboutcontent_pl", content?.data?.page_content_pl);
      setValue("aboutcontent_en", content?.data?.page_content_en);
      setValue("aboutcontent_fr", content?.data?.page_content_fr);
      setValue("aboutcontent_it", content?.data?.page_content_it);
      setValue("aboutcontent_sp", content?.data?.page_content_es);
    }
  }, [content]);

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const onSubmit = (data) => {
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "update-page",
      headers: {
        "x-access-token": token,
      },
      data: {
        id: id.pageId,
        page_title_en: data.page_title_en,
        page_title_fr: data.page_title_fr,
        page_title_it: data.page_title_it,
        page_title_es: data.page_title_sp,
        page_title_pl: data.page_title_pl,
        page_content_pl: data.aboutcontent_pl,
        page_content_es: data.aboutcontent_sp,
        page_content_en: data.aboutcontent_en,
        page_content_fr: data.aboutcontent_fr,
        page_content_it: data.aboutcontent_it,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          Swal.fire({
            title: response.data.message,
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navitage("/pages");
        }
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="bottom">
          <div className="modal-content">
            <div className="modal-content-title">Edit Content</div>
            <p>&nbsp;</p>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="custome-form-group">
                <label>Page Title English</label>
                <input
                  type="text"
                  name="page_title_en"
                  {...register("page_title_en", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.page_title_en && (
                  <div className="invalid-feedback">
                    {errors.page_title_en.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Title French</label>
                <input
                  type="text"
                  name="page_title_fr"
                  {...register("page_title_fr", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.page_title_fr && (
                  <div className="invalid-feedback">
                    {errors.page_title_fr.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Title Italian</label>
                <input
                  type="text"
                  name="page_title_it"
                  {...register("page_title_it", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.page_title_it && (
                  <div className="invalid-feedback">
                    {errors.page_title_it.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Title Spanish</label>
                <input
                  type="text"
                  name="page_title_sp"
                  {...register("page_title_sp", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.page_title_sp && (
                  <div className="invalid-feedback">
                    {errors.page_title_sp.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Title Polish</label>
                <input
                  type="text"
                  name="page_title_pl"
                  {...register("page_title_pl", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.page_title_pl && (
                  <div className="invalid-feedback">
                    {errors.page_title_pl.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Slug</label>
                <input
                  type="text"
                  name="slug"
                  disabled={true}
                  {...register("slug")}
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>Page Content English</label>

                {getValues("aboutcontent_en") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    data={
                      getValues("aboutcontent_en") !== undefined
                        ? getValues("aboutcontent_en")
                        : "loading"
                    }
                    name="aboutcontent_en"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("aboutcontent_en", editor.getData());
                    }}
                  />
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Content French</label>
                {getValues("aboutcontent_fr") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    data={
                      getValues("aboutcontent_fr") !== undefined
                        ? getValues("aboutcontent_fr")
                        : "loading"
                    }
                    name="aboutcontent_fr"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("aboutcontent_fr", editor.getData());
                    }}
                  />
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Content Italian</label>
                {getValues("aboutcontent_it") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    data={
                      getValues("aboutcontent_it") !== undefined
                        ? getValues("aboutcontent_it")
                        : "loading"
                    }
                    name="aboutcontent_it"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("aboutcontent_it", editor.getData());
                    }}
                  />
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Content Spanish</label>
                {getValues("aboutcontent_sp") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    data={
                      getValues("aboutcontent_sp") !== undefined
                        ? getValues("aboutcontent_sp")
                        : "loading"
                    }
                    name="aboutcontent_sp"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("aboutcontent_sp", editor.getData());
                    }}
                  />
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Content Polish</label>
                {getValues("aboutcontent_pl") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    data={
                      getValues("aboutcontent_pl") !== undefined
                        ? getValues("aboutcontent_pl")
                        : "loading"
                    }
                    name="aboutcontent_pl"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("aboutcontent_pl", editor.getData());
                    }}
                  />
                )}
              </div>
              <button type="submit" className="approveButton">
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editcontent;
